class DisplayListing {
  constructor() {}
}

export default new DisplayListing();
